import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { ArchitectureDiagram } from '../components/ArchitectureDiagram';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function HomeArchitecture() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-6122" />
      <ArchitectureDiagram data-id="element-6123" />
      <HowItWorksConnections mode="how" data-id="element-6124" />
      <LivesInSlack data-id="element-6125" />
      <ComputerUse data-id="element-6126" />
      <CapabilityGrid data-id="element-6127" />
      <NarrativeSection data-id="element-6128" />
      <ToolComparison data-id="element-6129" />
      <WallOfLove data-id="element-6130" />
      <PricingSection data-id="element-6131" />
      <ClosingCTA data-id="element-6132" />
    </>;
}